import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

// Popular ECB-covered currencies for the conversion estimate dropdown.
export const FX_CURRENCIES = ['EUR','USD','GBP','PLN','CHF','CZK','SEK','NOK','DKK','HUF','RON','BGN','AUD','CAD','JPY','TRY'];

export function CurrencyPreview({ amount, currency, apptId }) {
  const [to, setTo] = useState('');
  const [result, setResult] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (!to || to === currency) { setResult(null); setErr(''); return; }
    let alive = true;
    setResult(null);
    api.get('/fx/convert', { params: { amount, from_currency: currency, to_currency: to } })
      .then(r => { if (alive) { setResult(r.data); setErr(''); } })
      .catch(e => { if (alive) { setResult(null); setErr(e.response?.data?.detail || 'Estimate unavailable'); } });
    return () => { alive = false; };
  }, [to, amount, currency]);

  if (!amount || !currency) return null;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs" data-testid={`fx-preview-${apptId}`}>
      <span className="text-fg-muted">See amount in another currency:</span>
      <select className="input !py-1 !px-2 !w-auto text-xs" value={to}
              onChange={e => setTo(e.target.value)} data-testid={`fx-select-${apptId}`}>
        <option value="">— {currency} (charged) —</option>
        {FX_CURRENCIES.filter(c => c !== currency).map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      {result && (
        <span className="text-fg-secondary" data-testid={`fx-result-${apptId}`}>
          ≈ <strong>{result.converted} {result.to}</strong>
          <span className="text-fg-muted"> (rate {result.rate} · estimate — you'll be charged {Number(amount).toFixed(2)} {currency})</span>
        </span>
      )}
      {err && <span className="text-[#B83A3A]">{err}</span>}
    </div>
  );
}
